import {
	PRESCRIPTION_DRAFT_STATUS,
	PRESCRIPTION_PARTICULAR_KEYS,
	PRESCRIPTION_PARTICULAR_RULES,
	type PrescriptionDraft,
	type PrescriptionModality,
	type PrescriptionParticulars,
} from "../../types/healthcare/PrescriptionDraftTypes";

export const DRAFT_NOT_ISSUED_LABEL = "Draft — not issued";

export const isEditableDraft = (draft: PrescriptionDraft): boolean => draft.status === PRESCRIPTION_DRAFT_STATUS;

export const shortReference = (uuid: string | null | undefined): string => (uuid ? `…${uuid.slice(-8)}` : "—");

export const modalityLabel = (modality: PrescriptionModality): string => (modality === "paper" ? "Paper" : "Electronic");

export const medicineSummary = (particulars: PrescriptionParticulars): string =>
	[particulars.medicine_name, particulars.medicine_strength, particulars.medicine_form].filter((part) => part && part.trim() !== "").join(" · ") ||
	"Medicine not yet entered";

// CU-14ygtkjeh2z: blank text becomes null so a cleared field clears on the server rather than storing "".
export const normaliseParticulars = (values: Partial<Record<keyof PrescriptionParticulars, unknown>> | undefined): PrescriptionParticulars =>
	Object.fromEntries(
		PRESCRIPTION_PARTICULAR_KEYS.map((key) => {
			const raw = values?.[key];
			if (PRESCRIPTION_PARTICULAR_RULES[key].kind === "integer") {
				return [key, typeof raw === "number" && Number.isFinite(raw) ? Math.trunc(raw) : null];
			}
			const text = typeof raw === "string" ? raw.trim() : "";
			return [key, text === "" ? null : text];
		})
	) as unknown as PrescriptionParticulars;

export const changedParticulars = (base: PrescriptionParticulars, next: PrescriptionParticulars): Partial<PrescriptionParticulars> =>
	Object.fromEntries(PRESCRIPTION_PARTICULAR_KEYS.filter((key) => base[key] !== next[key]).map((key) => [key, next[key]]));

export const sameDraftContent = (
	draft: PrescriptionDraft,
	intended: { modality: PrescriptionModality; organisation_uuid: string; particulars: PrescriptionParticulars }
): boolean =>
	draft.modality === intended.modality &&
	draft.organisation_uuid === intended.organisation_uuid &&
	Object.keys(changedParticulars(draft.particulars, intended.particulars)).length === 0;
